import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { ServiceAdvisorFormStateService } from '../../service/service-advisor-formStateService';
import { UserService } from '../../../../Service/User/user.service';
import { FormlyFieldFileUploadComponent } from '../../../users/types/formly-field-file-upload.component';

@Component({
  selector: 'app-service-advisor-resume',
  templateUrl: './service-advisor-resume.component.html',
  styleUrls: ['./service-advisor-resume.component.scss'],
})
export class ServiceAdvisorResumeComponent implements OnInit {
  countryId: any;
  form = new FormGroup({});
  model: any = {};
  isNewFileUploaded = false;

  fields: FormlyFieldConfig[] = [];
  @Output() nextSection = new EventEmitter<void>();
  @Output() formValidity = new EventEmitter<boolean>();
  @Input() receivedObject: any;
  @Input() editMode!: boolean;

  constructor(
    private api: UserService,
    private formStateService: ServiceAdvisorFormStateService,
    private fileService: ServiceAdvisorFormStateService,
    private cdr: ChangeDetectorRef,
    private formlyConfig: FormlyConfig
  ) {}

  ngOnInit(): void {
    console.log('Initializing ServiceAdvisorResumeComponent');
    if (this.receivedObject) {
      this.populateFormWithServiceProviderDetails(this.receivedObject);
    }
    this.initializeFields();
     if (!this.formlyConfig.getType('file-upload')) {
          this.formlyConfig.setType({
            name: 'file-upload',
            component: FormlyFieldFileUploadComponent,
          });
        }
  }

  ngOnDestroy() {
    this.saveFormData();
  }

  resetForm() {
    this.form.reset();
    this.model = {};
  }

  initializeFields() {
    const fileSourceId = 3;
    this.fields = [
      {
        key: 'file',
        type: 'file-upload',
        templateOptions: {
          label: 'File Upload',
          placeholder: 'Upload a file',
          required: true,
          accept: '.pdf,.jpg,.png',
          fileSourceId,
        },
      },
    ];
  }

  patchFormWithFile(fileName: string, fileUrl: string, fileId: number) {
    this.form.patchValue({ file: fileUrl });

    // Update formStateService with file information
    this.fileService.setFormData('resumeFile', {
      fileName: fileName,
      fileUrl: fileUrl,
      fileId: fileId,
    });

    // Store uploaded file ID in fileService
    this.fileService.setUploadedFileId('resumeFile', fileId);

    this.cdr.detectChanges();
  }

  populateFormWithServiceProviderDetails(res: any) {
    const resumeDocument = res.serviceAdvisorDocuments?.find(
      (doc: any) => doc.documentTypeId === 12
    );

    const uploadedFileId = this.fileService.getUploadedFileId('resumeFile');

    if (!uploadedFileId && resumeDocument) {
      console.log('Patching backend resume data.');

      const { fileName, filePath: fileUrl, fileId } = resumeDocument;

      // Patch the form with file from backend using the new method
      this.patchFormWithFile(fileName, fileUrl, fileId);
    } else {
      console.log('Skipping backend patch, uploaded file ID exists:', uploadedFileId);
    }
    console.log('Model after patching', this.model)
    this.initializeFields()
  }

  saveFormData() {
    const formData: any = { ...this.form.value };

    const uploadedFileId = this.fileService.getUploadedFileId('resumeFile');
    console.log('Uploaded file id ::', uploadedFileId);

    if (uploadedFileId) {
      const documentTypeId = 12;
      const uploadDocs = {
        documents: [
          {
            documentTypeId,
            fileId: uploadedFileId,
          },
        ],
      };

      this.formStateService.setFormData('upload-documents', formData);
      this.formStateService.setServiceAdvisorResume(uploadDocs);
      console.log('Form data and uploaded document saved successfully');
    } else {
      console.error('No uploaded file ID found. Please ensure the file is uploaded.');
    }
  }

  loadFormData() {
    const savedData = this.formStateService.getFormData('upload-documents');
    if (savedData) {
      const { fileName, fileUrl, file } = savedData;
      console.log('Loaded saved data:', savedData);

      // Use the new centralized method to patch form and state
      this.patchFormWithFile(fileName, fileUrl, file);
    }
  }

  onSubmit() {
    this.saveFormData();
    this.nextSection.emit();
    const data = this.formStateService.getServiceAdvisorCombinedData();
    console.log(data);
  }
}
